import { CalendarCheck, CalendarClock, CalendarDays, CalendarPlus } from 'lucide-react';
import type { router as AppRouter } from '../../router';
import { registerCommands, type Command } from '../../shell/command-registry';

/**
 * S19's palette entries (06-qol §1: every screen registers itself). "Interviews" itself
 * comes from the module bar; these are its pages, each behind the §L23 object that opens it.
 */
export function registerInterviewCommands(router: typeof AppRouter): () => void {
  const commands: Command[] = [
    {
      id: 'interviews.calendar',
      label: 'Interview calendar',
      section: 'navigate',
      context: 'Interviews · SCH-02',
      permission: 'interview',
      icon: CalendarDays,
      keywords: ['interview', 'calendar', 'week', 'schedule', 'booked'],
      run: () => void router.navigate({ to: '/interviews' }),
    },
    {
      id: 'interviews.to-schedule',
      label: 'Interviews to schedule',
      section: 'navigate',
      context: 'Interviews · SCH-02',
      permission: 'job_config',
      icon: CalendarPlus,
      keywords: ['schedule', 'unscheduled', 'send times', 'slots', 'book'],
      run: () => void router.navigate({ to: '/interviews/to-schedule' }),
    },
    {
      id: 'interviews.mine',
      label: 'My interviews',
      section: 'navigate',
      context: 'Interviews · SCH-03',
      permission: 'interview',
      icon: CalendarCheck,
      keywords: ['my interviews', 'panel', 'panelist', 'upcoming', 'scorecard', 'cockpit', 'score'],
      run: () => void router.navigate({ to: '/interviews/mine' }),
    },
    {
      id: 'interviews.availability',
      label: 'My availability',
      section: 'navigate',
      context: 'Interviews · working hours and time off',
      permission: 'interview',
      icon: CalendarClock,
      keywords: ['availability', 'hours', 'leave', 'time off', 'away', 'block out'],
      run: () => void router.navigate({ to: '/interviews/availability' }),
    },
  ];
  return registerCommands(commands);
}
